// extracted by mini-css-extract-plugin
module.exports = {"web":"Web_web__2lxJO","web-option":"Web_web-option__15l3y"};